<ng-container *transloco="let t; prefix: 'uiKit.upload'">
  <input
    #fileInput
    type="file"
    [id]="idInput()"
    class="d-none"
    accept="image/*"
    (change)="onFileChange($event)"
  />
  <div
    class="upload-image"
    [class.upload-image--dragover]="isDragOver()"
    [class.upload-image--filled]="!!previewUrl()"
    (dragover)="onDragOver($event)"
    (dragleave)="isDragOver.set(false)"
    (drop)="onDrop($event)"
  >
    @if (previewUrl(); as preview) {
      <div class="upload-image__filled">
        <div class="upload-image__thumb">
          <img [src]="preview" alt="" />
        </div>
        <div class="upload-image__info">
          <div class="upload-image__name">
            {{ file()?.name || t('currentImage') }}
          </div>
          @if (file(); as file) {
            <div class="upload-image__meta">{{ file.size | fileSize }}</div>
          }
          <div class="upload-image__actions">
            <ui-button
              [size]="'sm'"
              [severity]="'light-primary'"
              [icon]="'arrows-circle'"
              [buttonText]="t('replace')"
              (click)="openPicker()"
            ></ui-button>
            <ui-button
              [size]="'sm'"
              [severity]="'light-danger'"
              [icon]="'trash'"
              [buttonText]="t('remove')"
              (click)="removeImage()"
            ></ui-button>
          </div>
        </div>
      </div>
    } @else {
      <label [for]="idInput()" class="upload-image__empty">
        <span class="upload-image__icon">
          <ui-keenicon
            [name]="'picture'"
            class="fs-2x text-primary"
          ></ui-keenicon>
        </span>
        <span class="upload-image__title">
          {{ t('drop') }}
          <span class="text-primary">{{ t('browse') }}</span>
        </span>
        @if (description()) {
          <span class="upload-image__hint">{{ description() }}</span>
        }
      </label>
    }
  </div>
  @if (description() && previewUrl()) {
    <div class="form-text">{{ description() }}</div>
  }
</ng-container>
